import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader';
import WhyHostFormBlock1 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock1';
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './WhyHostBlock1.css';

const WhyHostBlock1 = (props) => {
    const { data: { loading, getWhyHostPage }, title } = props;

    if (loading) return <Loader type={"text"} />;

    let settingsCollection = {};
    const dynamicMap = {};

    const BLOCK1_ACTIVE_FIELDS = ['hostBannerTitle1', 'hostBannerContent1', 'hostBannerContent2', 'buttonLabel', 'buttonLabel2'];
    getWhyHostPage?.forEach((item) => {
        settingsCollection[item.name] = item.value;

        if (BLOCK1_ACTIVE_FIELDS.includes(item.name)) {
            item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                if (!dynamicMap[dynItem.language]) {
                    dynamicMap[dynItem.language] = { language: dynItem.language };
                }
                dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
            });
        }
    });

    const dynamicValues = Object.values(dynamicMap);

    settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
        ? dynamicValues
        : [{
            language: '',
            hostBannerTitle1: settingsCollection.hostBannerTitle1,
            hostBannerContent1: settingsCollection.hostBannerContent1,
            hostBannerContent2: settingsCollection.hostBannerContent2,
            buttonLabel: settingsCollection.buttonLabel,
            buttonLabel2: settingsCollection.buttonLabel2,
            language: 'en'
        }];
    return <WhyHostFormBlock1 initialValues={settingsCollection} title={title} />;
};

WhyHostBlock1.defaultProps = {
    data: { loading: false }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: { fetchPolicy: 'network-only', ssr: false }
    }),
)(WhyHostBlock1);